<mat-toolbar color="primary" class="widget-toolbar">
    <span>Rapports de consultation</span>
    <span class="toolbar-spacer"></span>
    <!-- <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
        <mat-icon>search</mat-icon>
    </button>     -->
</mat-toolbar>
<div class="widget-table-container">
    <app-report-table #reporttable class="widget-content" [reports]="reports" [paginator]="false"></app-report-table>
</div>